import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

function useEditorialCollection(entries) {
  const [searchParams, setSearchParams] = useSearchParams();
  const query = (searchParams.get("q") || "").trim();
  const currentCategory = searchParams.get("category") || "all";
  const categories = useMemo(
    () => Array.from(new Set(entries.map((entry) => entry.category))),
    [entries]
  );

  const filteredEntries = useMemo(() => {
    const normalizedQuery = query.toLocaleLowerCase();

    return entries.filter((entry) => {
      const matchesCategory =
        currentCategory === "all" || entry.category === currentCategory;
      const searchableText = [entry.title, entry.excerpt, entry.category]
        .join(" ")
        .toLocaleLowerCase();
      const matchesQuery = !normalizedQuery || searchableText.includes(normalizedQuery);

      return matchesCategory && matchesQuery;
    });
  }, [currentCategory, entries, query]);

  const updateSearch = (category, nextQuery) => {
    const params = new URLSearchParams();
    if (category && category !== "all") params.set("category", category);
    if (nextQuery) params.set("q", nextQuery);
    setSearchParams(params);
  };

  return {
    categories,
    currentCategory,
    filteredEntries,
    query,
    setCategory: (category) => updateSearch(category, query),
    setQuery: (nextQuery, categoryOverride) =>
      updateSearch(categoryOverride || currentCategory, nextQuery),
  };
}

export default useEditorialCollection;
